import React, { useEffect, useState } from 'react';
import { AvisosCard } from './Avisos';
import { getAllNotices } from '../../../service/avisos/avisos';

interface Notice {
  id: number;
  title: string;
  description: string;
  carousel_image: string;
  additional_file: string;
  is_active: boolean;
  createdAt: string;
  updatedAt: string;
}

const View: React.FC = () => {
  const [notices, setNotices] = useState<Notice[]>([]);
  const [reloadData, setReloadData] = useState<boolean>(false);
  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const data = await getAllNotices();
        setNotices(data);
        setReloadData(false);
      } catch (error) {
        console.error('Error al obtener avisos:', error);
        setReloadData(false);
      }
    };
    fetchNotices();
  }, [reloadData]);

  return (
    <>
      {notices.map((notice, index) => (
        <AvisosCard
          key={notice.id || index}
          num_aviso={notice.id}
          title={notice.title || ''}
          show_app={notice.is_active || false}
          description={notice.description || ''}
          image={notice.carousel_image}
          file={notice.additional_file}
          id_aviso={notice.id || 0}
          date={new Date(notice.updatedAt).toISOString().split('T')[0]}
          handleReload={(updateGrid: boolean) => {
            if (updateGrid) {
              setReloadData(true);
            }
          }}
        />
      ))}
    </>
  );
};

export { View };
